module.exports = __webpack_public_path__ + "img/campaign-active.ac94a5a7.svg";